module.exports = __webpack_public_path__ + "img/intro_mock.c543e650.png";